export default "__VITE_ASSET__a7995f56__"